import { SET_URL_PROTOCOL } from "../actionTypes/configActionTypes";
import { IConfigAction } from "../interfaces/ConfigInterfaces";

export const setUrlProtocol = (value: string): IConfigAction => ({
  type: SET_URL_PROTOCOL,
  payload: value,
});
